import type { ViewerRelation } from '@/types/ticket'

export const isAdminViewer = (r: ViewerRelation) => r === 'admin'
export const isOwnerViewer = (r: ViewerRelation) => r === 'owner'
export const isColleagueViewer = (r: ViewerRelation) => r === 'colleague'
